import React from 'react';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router';
import Hero from 'components/Hero';
import RotatorScroll from 'components/RotatorScroll';
import FlexIconRow from 'components/FlexIconRow';
import Responsive from 'react-responsive';
import MediaRowCustomizable from 'components/MediaRowCustomizable';
import VideoRowCustomizable from 'components/VideoRowCustomizable';
import './Home.scss';


export default class Home extends React.Component {
    constructor (props) {
        super(props);
    }

    componentDidMount () {
    }


    render () {
        const DesktopXlLg = props => <Responsive {...props} minWidth={1920} />;
        const DesktopXlg = props => <Responsive {...props} minWidth={1440} maxWidth={1919}/>;
        const DesktopLg = props => <Responsive {...props} minWidth={1300} maxWidth={1439} />;
        const DesktopMd = props => <Responsive {...props} minWidth={1200} maxWidth={1299} />;
        const DesktopSm = props => <Responsive {...props} minWidth={1025} maxWidth={1199} />;
        const TabletLg = props => <Responsive {...props} minWidth={921} maxWidth={1024} />;
        const TabletMd = props => <Responsive {...props} minWidth={841} maxWidth={920} />;
        const TabletSm = props => <Responsive {...props} minWidth={770} maxWidth={840} />;
        const MobileLg = props => <Responsive {...props} minWidth={641} maxWidth={769} />;
        const MobileXmd = props => <Responsive {...props} minWidth={541} maxWidth={640} />;
        const MobileMd = props => <Responsive {...props} minWidth={416} maxWidth={540} />;
        const MobileSmLg = props => <Responsive {...props} minWidth={376} maxWidth={415} />;
        const MobileSm = props => <Responsive {...props} minWidth={321} maxWidth={375} />;
        const MobileXsm = props => <Responsive {...props} maxWidth={320} />;


        return (
            <section className='test-comp-div'>
                <Hero
                    videoSrcDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/dev/HIW/Hero/raining7.mp4.mp4'
                    videoSrcMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/dev/HIW/Hero/Raining_mobile.mp4.mp4'
                    poster='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Hero/Image+82.png'
                    posterMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Hero/poster+hero+1024.png'
                    title = 'Welcome to'
                    subtitle = 'NOON Pro'
                    description='HOME IN A NEW LIGHT'
                    isVid={true}
                />
                <div className='top-sec'>
                    <DesktopXlLg>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/Image+84.png'
                            textBoxWidth={640}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1340}
                            LeftPositionMargin={7}
                        />
                    </DesktopXlLg>
                    <DesktopXlg>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/Image+84.png'
                            textBoxWidth={640}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1340}
                            LeftPositionMargin={4}
                        />
                    </DesktopXlg>
                    <DesktopLg>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/Image+84.png'
                            textBoxWidth={570}
                            screenWidth={1439}
                            LeftPositionHotZoneMargin={709}
                            LeftPositionMargin={5}
                        />
                    </DesktopLg>
                    <DesktopMd>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/Image+84.png'
                            textBoxWidth={570}
                            screenWidth={1299}
                            LeftPositionHotZoneMargin={641}
                            LeftPositionMargin={3}
                        />
                    </DesktopMd>
                    <DesktopSm>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/Image+84.png'
                            textBoxWidth={549}
                            screenWidth={1199}
                            LeftPositionHotZoneMargin={729}
                            LeftPositionMargin={5}
                            positionX={35}
                            positionY={50}
                            imagePositionStyle = 'reposition'
                        />
                    </DesktopSm>
                    <TabletLg>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/Module1+1024.png'
                            lableWidth={660}
                        />
                    </TabletLg>
                    <TabletMd>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/module1+920.png'
                            lableWidth={660}
                        />
                    </TabletMd>
                    <TabletSm>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/module1+840.png'
                            lableWidth={660}
                        />
                    </TabletSm>
                    <MobileLg>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/module1+769.png'
                            lableWidth={660}
                        />
                    </MobileLg>
                    <MobileXmd>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/module1+640.png'
                            lableWidth={660}
                        />
                    </MobileXmd>
                    <MobileMd>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/module1+540.png'
                            lableWidth={660}
                        />
                    </MobileMd>
                    <MobileSmLg>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/module1+415.png'
                            lableWidth={660}
                        />
                    </MobileSmLg>
                    <MobileSm>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/module1+375.png'
                            lableWidth={660}
                        />
                    </MobileSm>
                    <MobileXsm>
                        <MediaRowCustomizable
                            title='NOON LIGHTING SYSTEM'
                            label="The smart lighting system that’s actually smart."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON Switches wirelessly communicate with each other to create coordinated light in beautiful, complementary levels. Use our automatically generated “scenes” or create your own to transform the look and feel of any room.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module1/module1+320.png'
                            lableWidth={660}
                        />
                    </MobileXsm>
                </div>

                <div className='generic-sec-hold'>
                    <DesktopXlLg>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON just works.</p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            textBoxWidth={592}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1480}
                            RightPositionMargin={12}
                            imgOpt='img--opt'
                        />
                    </DesktopXlLg>
                    <DesktopXlg>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON just works.</p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            textBoxWidth={592}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1480}
                            RightPositionMargin={7}
                            imgOpt='img--opt'
                        />
                    </DesktopXlg>
                    <DesktopLg>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON just works.</p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            textBoxWidth={525}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1480}
                            RightPositionMargin={4}
                            imgOpt='img--opt'
                        />
                    </DesktopLg>
                    <DesktopMd>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON just works.</p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            textBoxWidth={525}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1480}
                            RightPositionMargin={9}
                        />
                    </DesktopMd>
                    <DesktopSm>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON just works.</p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            textBoxWidth={525}
                            screenWidth={1199}
                            RightPositionHotZoneMargin={600}
                            RightPositionMargin={2}
                            hasAnim='rotator'
                        />
                    </DesktopSm>
                    <TabletLg>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON <nobr>just works.</nobr></p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            lableWidth={600}
                        />
                    </TabletLg>
                    <TabletMd>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON <nobr>just works.</nobr></p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            lableWidth={600}
                        />
                    </TabletMd>
                    <TabletSm>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON just works.</p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            lableWidth={600}
                        />
                    </TabletSm>
                    <MobileLg>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON just works.</p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            lableWidth={550}
                        />
                    </MobileLg>
                    <MobileXmd>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON just works.</p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            lableWidth={380}
                        />
                    </MobileXmd>
                    <MobileMd>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON <nobr>just works.</nobr></p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            lableWidth={360}
                        />
                    </MobileMd>
                    <MobileSmLg>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON <nobr>just works.</nobr></p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            lableWidth={300}
                        />
                    </MobileSmLg>
                    <MobileSm>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON just works.</p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            lableWidth={300}
                        />
                    </MobileSm>
                    <MobileXsm>
                        <MediaRowCustomizable
                            title="ONE BASE. MODULAR DESIGN."
                            label='Universal dimming base.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Works with all residential bulb and fixture types including LED, incandescent, halogen, fluorescent, CFL bulbs and MLV, ELV light fixtures. No separate switch for multi-way installations. NOON just works.</p>
                                <div className='icons-for-anim-holder'>
                                    <img className='amin-icon-im' src='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/exploder/exploder-icons.png'/>
                                </div>
                            </div>}
                            img={require("assets/img/director/director-exploder-bg.jpg")}
                            rotator={<RotatorScroll stopAnimating={true} width={1920} height={900} image={require("assets/img/director/director-exploder.png")} />}
                            lableWidth={300}
                        />
                    </MobileXsm>
                </div>

                <div className='generic-sec-hold vid'>
                    <DesktopXlLg>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Image+85.png'
                            videoSrcDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_Discovery_1920.mp4.mp4'
                            textBoxWidth={545}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1675}
                            LeftPositionMargin={9}
                        />
                    </DesktopXlLg>
                    <DesktopXlg>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Image+85.png'
                            videoSrcDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_Discovery_1920.mp4.mp4'
                            textBoxWidth={545}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1675}
                            LeftPositionMargin={9}
                        />
                    </DesktopXlg>
                    <DesktopLg>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Image+85.png'
                            videoSrcDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_Discovery_1920.mp4.mp4'
                            textBoxWidth={485}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1675}
                            LeftPositionMargin={8}
                        />
                    </DesktopLg>
                    <DesktopMd>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Image+85.png'
                            videoSrcDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_Discovery_1920.mp4.mp4'
                            textBoxWidth={485}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1675}
                            LeftPositionMargin={7}
                        />
                    </DesktopMd>
                    <DesktopSm>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Image+85.png'
                            videoSrcDesktop='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_Discovery_1920.mp4.mp4'
                            textBoxWidth={465}
                            screenWidth={1199}
                            LeftPositionHotZoneMargin={710}
                            LeftPositionMargin={5}
                        />
                    </DesktopSm>
                    <TabletLg>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures <nobr>while applying</nobr> the right dimming curves to ensure that there is <nobr>no flicker or buzz.</nobr></p>
                            </div>}
                            posterMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/poster3+1024.png'
                            videoSrcMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_discovery_960.mp4.mp4'
                            lableWidth={600}
                        />
                    </TabletLg>
                    <TabletMd>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/poster3+1024.png'
                            videoSrcMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_discovery_960.mp4.mp4'
                            lableWidth={600}
                        />
                    </TabletMd>
                    <TabletSm>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/poster3+1024.png'
                            videoSrcMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_discovery_960.mp4.mp4'
                            lableWidth={600}
                        />
                    </TabletSm>
                    <MobileLg>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/poster3+1024.png'
                            videoSrcMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_discovery_960.mp4.mp4'
                            lableWidth={600}
                        />
                    </MobileLg>
                    <MobileXmd>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/poster3+1024.png'
                            videoSrcMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_discovery_960.mp4.mp4'
                            lableWidth={600}
                        />
                    </MobileXmd>
                    <MobileMd>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/poster3+1024.png'
                            videoSrcMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_discovery_960.mp4.mp4'
                            lableWidth={600}
                        />
                    </MobileMd>
                    <MobileSmLg>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/poster3+1024.png'
                            videoSrcMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_discovery_960.mp4.mp4'
                            lableWidth={600}
                        />
                    </MobileSmLg>
                    <MobileSm>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/poster3+1024.png'
                            videoSrcMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_discovery_960.mp4.mp4'
                            lableWidth={600}
                        />
                    </MobileSm>
                    <MobileXsm>
                        <VideoRowCustomizable
                            title='AUTOMATIC BULB DETECTION'
                            label="Bulb discovery."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Only NOON uses algorithms to detect bulb types of fixtures while applying the right dimming curves to ensure that there is no flicker or buzz.</p>
                            </div>}
                            posterMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/poster3+1024.png'
                            videoSrcMobile='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module3/Pro_discovery_960.mp4.mp4'
                            lableWidth={600}
                        />
                    </MobileXsm>
                </div>


                <div className='generic-sec-hold below-vid'>
                    <DesktopXlLg>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/Image+58.png'
                            textBoxWidth={565}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1591}
                            RightPositionMargin={10}
                        />
                    </DesktopXlLg>
                    <DesktopXlg>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/Image+58.png'
                            textBoxWidth={557}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1591}
                            RightPositionMargin={10}
                        />
                    </DesktopXlg>
                    <DesktopLg>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/Image+58.png'
                            textBoxWidth={510}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1591}
                            RightPositionMargin={8}
                        />
                    </DesktopLg>
                    <DesktopMd>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/Image+58.png'
                            textBoxWidth={502}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1591}
                            RightPositionMargin={8}
                        />
                    </DesktopMd>
                    <DesktopSm>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/Image+58.png'
                            textBoxWidth={482}
                            screenWidth={1199}
                            RightPositionHotZoneMargin={564}
                            RightPositionMargin={7}
                            positionX={35}
                            positionY={50}
                        />
                    </DesktopSm>
                    <TabletLg>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/Module4+1024.png'
                            lableWidth={600}
                        />
                    </TabletLg>
                    <TabletMd>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/module4+920.png'
                            lableWidth={600}
                        />
                    </TabletMd>
                    <TabletSm>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/module4+840.png'
                            lableWidth={600}
                        />
                    </TabletSm>
                    <MobileLg>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/module4+769.png'
                            lableWidth={600}
                        />
                    </MobileLg>
                    <MobileXmd>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or <nobr>wall plates</nobr> that ensure dimmers are perfectly aligned <nobr>every time.</nobr></p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/module4+640.png'
                            lableWidth={600}
                        />
                    </MobileXmd>
                    <MobileMd>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/module4+540.png'
                            lableWidth={600}
                        />
                    </MobileMd>
                    <MobileSmLg>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/module4+415.png'
                            lableWidth={600}
                        />
                    </MobileSmLg>
                    <MobileSm>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/module4+375.png'
                            lableWidth={600}
                        />
                    </MobileSm>
                    <MobileXsm>
                        <MediaRowCustomizable
                            title='DESIGNED WITH THE PRO IN MIND'
                            label='Easy to install.'
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">We design our products for easy, hassle-free installation with features such as interchangeable line and load or wall plates that ensure dimmers are perfectly aligned every time.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module4/module4+320.png'
                            lableWidth={600}
                        />
                    </MobileXsm>
                </div>

                <div className='generic-sec-hold'>
                    <DesktopXlLg>
                        <DesktopXlLg>
                            <MediaRowCustomizable
                                title='EASY SET UP IN THE APP'
                                label="Set the scene."
                                textBoxPosition='left'
                                content={<div key="4" className="full-bleed-comtent " >
                                    <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                                </div>}
                                img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/Image+86.png'
                                textBoxWidth={525}
                                screenWidth={2800}
                                LeftPositionHotZoneMargin={1574}
                                LeftPositionMargin={9}
                            />
                        </DesktopXlLg>
                    </DesktopXlLg>
                    <DesktopXlg>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/Image+86.png'
                            textBoxWidth={525}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1574}
                            LeftPositionMargin={9}
                        />
                    </DesktopXlg>
                    <DesktopLg>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/Image+86.png'
                            textBoxWidth={465}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1574}
                            LeftPositionMargin={7}
                        />
                    </DesktopLg>
                    <DesktopMd>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/Image+86.png'
                            textBoxWidth={465}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1574}
                            LeftPositionMargin={7}
                        />
                    </DesktopMd>
                    <DesktopSm>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/Image+86.png'
                            textBoxWidth={450}
                            screenWidth={1199}
                            LeftPositionHotZoneMargin={631}
                            LeftPositionMargin={5}
                            positionX={60}
                            positionY={0}
                        />
                    </DesktopSm>
                    <TabletLg>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/Module5+1024.png'
                            lableWidth={600}
                        />
                    </TabletLg>
                    <TabletMd>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/module5+920.png'
                            lableWidth={600}
                        />
                    </TabletMd>
                    <TabletSm>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/module5+840.png'
                            lableWidth={600}
                        />
                    </TabletSm>
                    <MobileLg>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/module5+769.png'
                            lableWidth={600}
                        />
                    </MobileLg>
                    <MobileXmd>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/module5+640.png'
                            lableWidth={600}
                        />
                    </MobileXmd>
                    <MobileMd>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time <nobr>and no</nobr> rewiring. They automatically create the <nobr>most beautiful</nobr> scenes for each room in which <nobr>they’re installed.</nobr></p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/module5+540.png'
                            lableWidth={600}
                        />
                    </MobileMd>
                    <MobileSmLg>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/module5+415.png'
                            lableWidth={600}
                        />
                    </MobileSmLg>
                    <MobileSm>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/module5+375.png'
                            lableWidth={600}
                        />
                    </MobileSm>
                    <MobileXsm>
                        <MediaRowCustomizable
                            title='EASY SET UP IN THE APP'
                            label="Set the scene."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">NOON dimmers require no programming time and no rewiring. They automatically create the most beautiful scenes for each room in which they’re installed.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module5/module5+320.png'
                            lableWidth={600}
                        />
                    </MobileXsm>
                </div>

                <div className='generic-sec-hold'>
                    <DesktopXlLg>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/Image+89.png'
                            textBoxWidth={501}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1640}
                            RightPositionMargin={11}

                        />
                    </DesktopXlLg>
                    <DesktopXlg>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/Image+89.png'
                            textBoxWidth={501}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1640}
                            RightPositionMargin={9}

                        />
                    </DesktopXlg>
                    <DesktopLg>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/Image+89.png'
                            textBoxWidth={445}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1640}
                            RightPositionMargin={7}

                        />
                    </DesktopLg>
                    <DesktopMd>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/Image+89.png'
                            textBoxWidth={445}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1640}
                            RightPositionMargin={8}

                        />
                    </DesktopMd>
                    <DesktopSm>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/Image+89.png'
                            textBoxWidth={424}
                            screenWidth={1199}
                            RightPositionHotZoneMargin={500}
                            RightPositionMargin={3}

                        />
                    </DesktopSm>
                    <TabletLg>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img= 'https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/Module6+1024.png'
                            lableWidth={600}
                        />
                    </TabletLg>
                    <TabletMd>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to <nobr>maintain. Learn</nobr> what’s unique about NOON and how it benefits <nobr>your customers.</nobr></p>
                            </div>}
                            img= 'https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/module6+920.png'
                            lableWidth={600}
                        />
                    </TabletMd>
                    <TabletSm>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img= 'https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/module6+840.png'
                            lableWidth={600}
                        />
                    </TabletSm>
                    <MobileLg>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/module6+769.png'
                            lableWidth={600}
                        />
                    </MobileLg>
                    <MobileXmd>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/module6+640.png'
                            lableWidth={600}
                        />
                    </MobileXmd>
                    <MobileMd>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/module6+540.png'
                            lableWidth={600}
                        />
                    </MobileMd>
                    <MobileSmLg>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/module6+415.png'
                            lableWidth={600}
                        />
                    </MobileSmLg>
                    <MobileSm>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits <nobr>your customers.</nobr></p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/module6+375.png'
                            lableWidth={600}
                        />
                    </MobileSm>
                    <MobileXsm>
                        <MediaRowCustomizable
                            title='MEMBERSHIP PRIVILEGES'
                            label="Just for pros."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Certification is free and doesn’t require a sales minimum to maintain. Learn what’s unique about NOON and how it benefits your customers.</p>
                            </div>}
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module6/module6+320.png'
                            lableWidth={600}
                        />
                    </MobileXsm>
                </div>

                <section className='medrow-generic-tile-row-opt'>
                    <FlexIconRow
                        img1='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Icons/Group+84.png'
                        img2='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Icons/Group+42.png'
                        img3='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Icons/Group+47.png'
                        img4='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Icons/Group+50.png'
                        img5='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Icons/Group+52.png'
                        img6='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Icons/Group+51.png'
                    />
                </section>

                <div className='generic-sec-hold'>
                    <DesktopXlLg>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/sec3/plans.jpg'
                            textBoxWidth={590}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1574}
                            LeftPositionMargin={5}
                        />
                    </DesktopXlLg>
                    <DesktopXlg>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/sec3/plans.jpg'
                            textBoxWidth={590}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1242}
                            LeftPositionMargin={5}
                        />
                    </DesktopXlg>
                    <DesktopLg>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/sec3/plans.jpg'
                            textBoxWidth={526}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1242}
                            LeftPositionMargin={5}
                        />
                    </DesktopLg>
                    <DesktopMd>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/sec3/plans.jpg'
                            textBoxWidth={526}
                            screenWidth={2800}
                            LeftPositionHotZoneMargin={1242}
                            LeftPositionMargin={5}
                        />
                    </DesktopMd>
                    <DesktopSm>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://s3-us-west-2.amazonaws.com/com-noonhome-web/dev/BuildersPage/sec3/plans.jpg'
                            textBoxWidth={510}
                            screenWidth={1199}
                            LeftPositionHotZoneMargin={705}
                            LeftPositionMargin={5}
                        />
                    </DesktopSm>
                    <TabletLg>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module7/Module7+1024.png'
                            lableWidth={600}
                        />
                    </TabletLg>
                    <TabletMd>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module7/module7+920.png'
                            lableWidth={600}
                        />
                    </TabletMd>
                    <TabletSm>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module7/module7+840.png'
                            lableWidth={600}
                        />
                    </TabletSm>
                    <MobileLg>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module7/module7+769.png'
                            lableWidth={560}
                        />
                    </MobileLg>
                    <MobileXmd>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module7/module7+640.png'
                            lableWidth={360}
                        />
                    </MobileXmd>
                    <MobileMd>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module7/module7+540.png'
                            lableWidth={380}
                        />
                    </MobileMd>
                    <MobileSmLg>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module7/module7+415.png'
                            lableWidth={300}
                        />
                    </MobileSmLg>
                    <MobileSm>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, giving you detailed plans indicating placement and the number of switches you will need. Let us do the work.</p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module7/module7+375.png'
                            lableWidth={300}
                        />
                    </MobileSm>
                    <MobileXsm>
                        <MediaRowCustomizable
                            title='WE‘LL SPEC YOUR PROJECT'
                            label="Leave the planning to us."
                            textBoxPosition='left'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Send us your lighting plans and we’ll spec the entire project for you, <nobr>giving you</nobr> detailed plans indicating placement and the number of switches you will need. Let us do <nobr>the work.</nobr></p>
                            </div>}
                            ctalabel='CONTACT US'
                            ctaroute='https://www.noonhome.com/contact'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module7/module7+320.png'
                            lableWidth={300}
                        />
                    </MobileXsm>
                </div>

                <div className='generic-sec-hold'>
                    <DesktopXlLg>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/Image+90.png'
                            textBoxWidth={525}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1400}
                            RightPositionMargin={11}
                        />
                    </DesktopXlLg>
                    <DesktopXlg>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/Image+90.png'
                            textBoxWidth={525}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1400}
                            RightPositionMargin={9}
                        />
                    </DesktopXlg>
                    <DesktopLg>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/Image+90.png'
                            textBoxWidth={468}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1400}
                            RightPositionMargin={7}
                        />
                    </DesktopLg>
                    <DesktopMd>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/Image+90.png'
                            textBoxWidth={468}
                            screenWidth={2800}
                            RightPositionHotZoneMargin={1400}
                            RightPositionMargin={8}
                        />
                    </DesktopMd>
                    <DesktopSm>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/Image+90.png'
                            textBoxWidth={450}
                            screenWidth={1199}
                            RightPositionHotZoneMargin={540}
                            RightPositionMargin={3}
                        />
                    </DesktopSm>
                    <TabletLg>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/Module8+1024.png'
                            lableWidth={560}
                        />
                    </TabletLg>
                    <TabletMd>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/module8+920.png'
                            lableWidth={560}
                        />
                    </TabletMd>
                    <TabletSm>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/module8+840.png'
                            lableWidth={560}
                        />
                    </TabletSm>
                    <MobileLg>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/module8+769.png'
                            lableWidth={500}
                        />
                    </MobileLg>
                    <MobileXmd>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/module8+640.png'
                            lableWidth={500}
                        />
                    </MobileXmd>
                    <MobileMd>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/module8+540.png'
                            lableWidth={355}
                        />
                    </MobileMd>
                    <MobileSmLg>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/module8+415.png'
                            lableWidth={280}
                        />
                    </MobileSmLg>
                    <MobileSm>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/module8+375.png'
                            lableWidth={280}
                        />
                    </MobileSm>
                    <MobileXsm>
                        <MediaRowCustomizable
                            ctaBoxCustom='cta-box-custom-others'
                            textBoxType='ctaBox'
                            label="It's time to make a switch."
                            textBoxPosition='right'
                            content={<div key="4" className="full-bleed-comtent " >
                                <p className="full-bleed-text ">Become a NOON Pro and start to sell and install the award-winning products that are transforming lighting in the home.</p>
                            </div>}
                            ctalabel='SIGN UP'
                            ctaroute='/signup'
                            img='https://com-noonhome-web.s3-us-west-2.amazonaws.com/Pro/HomePage/NewHome/Module8/module8+320.png'
                            lableWidth={280}
                        />
                    </MobileXsm>
                </div>

            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/Home/index.js